import {View} from 'MWC';
import tpl from '../templates/CustomDropdown.jsx';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            active: false
        };

        this.toggleActive = this.toggleActive.bind(this);
    }

    toggleActive() {
        if (this.props.data) {
            this.props.toggleModal(null, this.props.data.id);
        } else {
            this.setState(prevState => ({
                active: !prevState.active
            }));
        }
    }

    static defaultProps = {
        title: 'Put your title here',
        id: ''
    };
}
